import React from "react";
import AsyncSelect from "react-select/async";
import CamplaCoreService from "../../services/CamplaCoreService";
import equals from "fast-deep-equal";
import { withTranslation } from "react-i18next";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const debounce = require("es6-promise-debounce");

class TagSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newValue: "",
      lastLookupValue: "",
      lastInputTime: 0,
      lastLookupTime: 0,
      lastResult: [],
      selectedTags: [],
      errorMessage: "",
    };

    this.loadOptions = this.loadOptions.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.tagSelectionRef = React.createRef();
  }

  async loadOptions(inputValue, callback) {
    const now = Date.now();
    if (now - this.state.lastLookupTime > 1000 && inputValue.length >= 2) {
      const lookupResult = await CamplaCoreService.getInstanceTemplateTags(
        inputValue,
      );
      this.setState({
        lastLookupValue: inputValue,
        lastResult: [...lookupResult],
        lastLookupTime: now,
      });
      callback(lookupResult);
    } else {
      callback(this.state.lastResult || []);
    }
  }

  async handleInputChange(newValue) {
    this.setState({
      lastInputTime: Date.now(),
    });

    newValue = newValue.trim();
    newValue = newValue.replace(/\s\s+/g, " ");
    this.setState({
      newValue: newValue,
    });

    const newTags = [];

    const separators = ["\n", " "];
    let separator = null;
    for (let sep of separators) {
      if (newValue.includes(sep)) {
        separator = sep;
        break;
      }
    }
    if (separator) {
      const tags = new Set(newValue.split(separator));
      for (const tag of Array.from(tags)) {
        newTags.push(tag);
      }
      const tagSet = new Set([...newTags, ...this.state.selectedTags]);
      let updatedTags = Array.from(tagSet);
      if (this.props.max && updatedTags.length >= this.props.max) {
        updatedTags = updatedTags.slice(0, this.props.max);
      }
      this.setState({
        selectedTags: updatedTags,
        newValue: "",
      });
      this.props.onChange(updatedTags);
    }

    if (this.props.max && this.state.selectedTags.length >= this.props.max) {
      this.setState({
        newValue: "",
      });
      return "";
    }
    return newValue;
  }

  componentDidMount() {
    if (this.props.selectedTags) {
      this.setState({
        selectedTags: this.props.selectedTags,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedTags &&
      !equals(this.props.selectedTags, prevProps.selectedTags) &&
      typeof this.props.selectedTags[Symbol.iterator] === "function"
    ) {
      this.setState({
        selectedTags: [...this.props.selectedTags],
      });
    }
  }

  onKeyDown(e) {
    if (e.key === "Enter" || e.keyCode === 32 || e.key === "Tab") {
      e.preventDefault();
      if (this.state.newValue?.length >= 2) {
        if (
          this.props.max &&
          this.state.selectedTags.length >= this.props.max
        ) {
          return;
        }
        const change = this.state.selectedTags.includes(this.state.newValue)
          ? this.state.selectedTags
          : Array.from(
              new Set([...this.state.selectedTags, this.state.newValue]),
            );
        this.setState({
          selectedTags: change,
          newValue: "",
        });
        this.props.onChange(change);
      }
    }
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <AsyncSelect
          ref={this.tagSelectionRef}
          styles={{
            control: (base, state) => ({
              ...base,
              boxShadow: state.isFocused
                ? "0 0 0 0.15rem rgba(67, 152, 112, 0.25)"
                : 0,
              borderColor: state.isFocused ? "#54BF8D" : base.borderColor,
              "&:hover": {
                borderColor: state.isFocused ? "#54BF8D" : base.borderColor,
              },
            }),
            option: (provided, { isSelected }) => ({
              ...provided,
              backgroundColor: isSelected ? "#b2c9c4" : "#FFFFFF",
              "&:hover": {
                backgroundColor: "#54BF8D",
                color: "#FFFFFF",
              },
            }),
            menuPortal: (provided) => ({
              ...provided,
              zIndex: 9999,
            }),
          }}
          noOptionsMessage={() => t("NoSelectOption")}
          loadingMessage={() => <FontAwesomeIcon icon={faCircleNotch} spin />}
          loadOptions={debounce(this.loadOptions, 1000)}
          onInputChange={(newValue) => this.handleInputChange(newValue)}
          inputValue={this.state.newValue}
          getOptionLabel={(option) => option}
          getOptionValue={(option) => option}
          hideSelectedOptions={false}
          onKeyDown={this.onKeyDown}
          value={this.state.selectedTags || []}
          isMulti={true}
          onBlur={this.onBlur}
          {...this.props}
        />
      </>
    );
  }
}

export default withTranslation()(TagSelection);
